export const GUIDELINE_EXPANDER_CARD_LABELS = {
  UNAVAILABLE: 'Citation unavailable — the guideline details could not be loaded.',
};
